import { useRef } from 'react'
import type { ParentRefProps } from '../DataField/types'

export const useFieldRefs = () => {
  const inputRef = useRef<HTMLInputElement>(null)
  const parentRef = useRef<ParentRefProps>({
    onChangeInputValue: () => ({})
  })

  return { inputRef, parentRef }
}
